import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from 'ui/styled'
import RoadmapPdf from 'pages/Roadmap/components/RoadmapPdf/RoadmapPdf'
import CarePlan from 'model/carePlans/carePlan'
import StepControlsWrapper from './styled'

const { Title } = Typography

const style = {
  minWidth: '150px',
  margin: '0 0 0 15px',
  backgroundColor: '#2064D2',
  color: 'white',
  lineHeight: 'inherit'
}

const StepControls = ({
  step,
  setStep,
  disabled,
  hintText,
  onCarePlanAction,
  carePlan
}) => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const isFirstStep = step === 0
  const isLastStep = step === 3
  const backToBundleStep = step === 1
  const {
    member: { register_status }
  } = carePlan
  const isUserRegistered = register_status === 'registered'
  const buttonAction = () =>
    isLastStep ? onCarePlanAction(false, 'submit') : setStep(step + 1)

  const onBackButtonClick = () => {
    // Reset entity search params
    navigate(pathname)

    if (backToBundleStep) {
      onCarePlanAction(false, 'stop')
      setStep(0)
    } else {
      setStep(step - 1)
    }
  }

  return (
    <StepControlsWrapper>
      <Title level={4}>{hintText}</Title>
      <div>
        {!isFirstStep && (
          <Button
            onClick={onBackButtonClick}
            minwidth="150px"
            margin="0 0 0 15px"
            data-test="carePlanBuilderBackBtn"
          >
            Back
          </Button>
        )}
        {isLastStep && !isUserRegistered ? (
          <RoadmapPdf
            carePlan={carePlan}
            style={style}
            buttonAction={buttonAction}
          />
        ) : (
          !isFirstStep && (
            <Button
              btntype="primary"
              onClick={buttonAction}
              minwidth="150px"
              margin="0 0 0 15px"
              disabled={disabled}
              data-test="carePlanBuilderNextSendBtn"
            >
              {isLastStep ? 'Send Care Plan to Recipient' : 'Next'}
            </Button>
          )
        )}
      </div>
    </StepControlsWrapper>
  )
}

StepControls.propTypes = {
  step: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  hintText: PropTypes.string.isRequired,
  onCarePlanAction: PropTypes.func.isRequired,
  carePlan: PropTypes.shape(CarePlan.shape).isRequired
}

export default StepControls
